// extracted by mini-css-extract-plugin
export default {"input":"SearchInput_input__9fNuO","inputDisabled":"SearchInput_inputDisabled__kIlXa"};